import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useQueryClient} from "react-query";
import moment from "moment-timezone";
import {useSnackbar} from "notistack";
import 'react-datepicker/dist/react-datepicker.css';

import {AGRISMART, ALERTS, getErrorMessage, post} from "../../service/Client";
import { useGetAlerts, useGetDevices } from "../../service/AgrismartService";
import NTMTable from "../../components/Table/NTMTable";
import FilterAndSearch from "../../components/FilterAndSearch";
import {Row} from "../../components/Layout";
import Image from "../../components/Image";
import EditLabelModal from "../../components/Modal/EditLabelModal";
import CloseAlertModal from "../../components/Modal/CloseAlertModal";
import NTMButton from "../../components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import { editIcon_over, editIcon_popUp } from 'img/icons'
import {roles} from "../../constants";

export default function AgrismartAlertLogPage() {
	let {alerts} = useGetAlerts();
	let {devices} = useGetDevices();
	const queryClient = useQueryClient()
	let user = useSelector(store => store.users.data);

	let [device, setDevice] = useState();
	let [selected, setSelected] = useState(null)
	let [search, setSearch] = useState(null)
	let [data, setData] = useState([])
	let [modalOpen, setModalOpen] = useState();
	let [closeAlertModalOpen, setCloseAlertModalOpen] = useState();
	const {enqueueSnackbar} = useSnackbar();

	useEffect(() => {
		if(alerts.length === 0) return
		let data = alerts.filter(a => a.device === device);
		if(selected === "Aperto") {
			data = data.filter(a => !a.closingTime)
		} else if(selected === "Chiuso") {
			data = data.filter(a => !!a.closingTime);
		}
		if(search && search !== "") {
			data = data.filter(a => a.typeLabel.toLowerCase().includes(search.toLowerCase()))
		}
		data.sort((a, b) => b.openTime - a.openTime);
		setData(data)
	}, [selected, search, alerts, device])

	function showError(e)  {
		enqueueSnackbar(getErrorMessage(e), {variant: "error"});
	}

	function changeNote(note) {
		post(`${AGRISMART}/${ALERTS}/${modalOpen}/note`, {body: note, headers: {"Content-Type": "text/plain"}})
			.then(() => queryClient.invalidateQueries('alerts'))
			.catch(showError);
		setModalOpen(null);
	}
	function closeAlert(silUntil) {
		post(`${AGRISMART}/${ALERTS}/${closeAlertModalOpen}/close`, {params: {silUntil}})
			.then(() => queryClient.invalidateQueries('alerts'))
			.catch(showError);
		setCloseAlertModalOpen(null);
	}

	if(!device && devices.length > 0) {
		setDevice(devices[0].device)
	}

	return (
		<div className="animated fadeIn">
			<Row>
				<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
					{devices.map(d =>
						<option key={d.device} value={d.device}>{d.label || d.device}</option>
					)}
				</NTMSelect>
				<FilterAndSearch
					filter={["Aperto", "Chiuso"]}
					onFilter={(selected) => setSelected(selected)}
					onSearch={search => setSearch(search)}
					selected={selected}
					allButton
				/>
			</Row>
			<div style={{ minHeight:400, margin: "1rem auto" }}>
				<NTMTable
					header={[
						{
							Header: "Tipologia",
							accessor: 'typeLabel'
						},
						{
							Header: "Apertura",
							accessor: 'openTime',
							Cell: props => <div>{moment(props.original.openTime).format("DD/MM/YYYY HH:mm")}</div>
						},
						{
							Header: "Chiusura",
							accessor: 'closingTime',
							Cell: props => <div>{
								props.original.closingTime ?
									moment(props.original.closingTime).format("DD/MM/YYYY HH:mm") : roles.isAdmin(user) &&
									<Row style={{justifyContent: "space-around"}}>
										<NTMButton outline primary onClick={() => setCloseAlertModalOpen(props.original.id)}>Chiudi</NTMButton>
									</Row>
							}</div>
						},
						{
							Header: "Descrizione",
							accessor: 'description',
							Cell: props => <div style={{textAlign: "left", whiteSpace: "normal"}}>
								{props.original.description}
							</div>
						},
						{
							Header: "Come intervenire",
							accessor: 'advice',
							Cell: props => <div style={{textAlign: "left", whiteSpace: "normal"}}>
								{props.original.advice}
							</div>
						},
						{
							Header: "Note",
							accessor: 'note',
							Cell: props => <Row style={{justifyContent: "space-around"}}>
									<span
										style={{paddingRight: "0.5rem"}}>{props.original.note || ""}</span>
								{roles.isAdmin(user) && <Image
									src={editIcon_popUp}
									hover={editIcon_over}
									onClick={() => setModalOpen(props.original.id)}
								/>}
							</Row>
						}
					]}
					body={data}
					defaultPageSize={10}
				/>
			</div>
			<EditLabelModal
				placeholder={"Annotazione..."}
				isOpen={!!modalOpen}
				onClose={() => setModalOpen(!modalOpen)}
				onSubmit={changeNote}
			/>
			<CloseAlertModal
				isOpen={!!closeAlertModalOpen}
				onClose={() => setCloseAlertModalOpen(!closeAlertModalOpen)}
				onSubmit={closeAlert}
				agrismartType={true}
			/>
		</div>
	);
}
